import StarIconFilled from '@atlaskit/icon/glyph/star-filled';
import React from 'react';
import { EMPTY_STAR, TOTAL_STARS } from './Ratings.constants';
import { AverageStars, NoRatingContainer, NoRatingText, NumericRatingStyled, RatingsContainer, RatingsCountStyled, StarIconContainer, StarRatingStyled, TotalStars } from './Ratings.styles';
import { getStarVariations, roundRatingToOneDecimal } from './Ratings.utils';
import { StarGradients } from './StarGradients';
const NumericRating = _ref => {
  let {
    avgStars,
    boldAverageStars
  } = _ref;
  return /*#__PURE__*/React.createElement(NumericRatingStyled, null, /*#__PURE__*/React.createElement(AverageStars, {
    isBold: boldAverageStars
  }, avgStars), /*#__PURE__*/React.createElement(TotalStars, null, "/", TOTAL_STARS));
};
const StarRating = _ref2 => {
  let {
    ratings,
    size = 'medium'
  } = _ref2;
  const stars = getStarVariations(ratings);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StarGradients, null), /*#__PURE__*/React.createElement(StarRatingStyled, null, stars.map((variation, index) => /*#__PURE__*/React.createElement(StarIconContainer, {
    key: index,
    "data-testid": "star-rating-".concat(variation),
    variation: variation,
    size: size
  }, /*#__PURE__*/React.createElement(StarIconFilled, {
    label: "Star rating",
    size: size
  })))));
};
const RatingsCount = _ref3 => {
  let {
    numRatings
  } = _ref3;
  return /*#__PURE__*/React.createElement(RatingsCountStyled, null, "(", numRatings, ")");
};
export const NoRatingsMessage = _ref4 => {
  let {
    testId,
    size = 'medium'
  } = _ref4;
  return /*#__PURE__*/React.createElement(NoRatingContainer, null, /*#__PURE__*/React.createElement(StarIconContainer, {
    "data-testid": testId,
    variation: EMPTY_STAR,
    size: size
  }, /*#__PURE__*/React.createElement(StarIconFilled, {
    label: "No star rating yet",
    size: size
  })), /*#__PURE__*/React.createElement(NoRatingText, null, "No reviews yet"));
};
export const Ratings = _ref5 => {
  let {
    testId,
    ratings,
    size,
    showNumberRatings = true,
    showNoRatingsMessage = false,
    boldAverageStars = false
  } = _ref5;
  const {
    avgStars,
    numRatings
  } = ratings;
  const roundRating = roundRatingToOneDecimal(avgStars || 0);
  return /*#__PURE__*/React.createElement("div", {
    role: "img",
    "data-testid": testId,
    "aria-label": "Rating of ".concat(roundRating, " out of ").concat(TOTAL_STARS, " stars based on ").concat(numRatings, " reviews")
  }, showNoRatingsMessage && !numRatings ? /*#__PURE__*/React.createElement(NoRatingsMessage, {
    testId: testId,
    size: size
  }) : /*#__PURE__*/React.createElement(RatingsContainer, {
    "aria-hidden": "true"
  }, showNumberRatings && !!numRatings && /*#__PURE__*/React.createElement(NumericRating, {
    boldAverageStars: boldAverageStars,
    avgStars: roundRating
  }), /*#__PURE__*/React.createElement(StarRating, {
    ratings: ratings,
    size: size
  }), showNumberRatings && !!numRatings && /*#__PURE__*/React.createElement(RatingsCount, {
    numRatings: numRatings
  })));
};